import checkIfReallyOnline from 'is-online';

import AbstractNetworkDetector from './AbstractNetworkDetector';
import { NetworkStatus } from './NetworkDetector'; // eslint-disable-line import/no-cycle
import { isCi, isExtension } from './utils/environment';

/*
  Safari doesn't support private class methods yet, so we use a `_` prefix instead.
  Please add/remove it when making something private/public.
*/
class NetworkDetector extends AbstractNetworkDetector<boolean> {
  constructor() {
    super({
      forcedStatus: isCi ? NetworkStatus.Online : null,
      shouldCreateToastOnConfirmedStatusChanges: !isExtension,
    });

    this._initialize();
  }

  protected _getCurrentPlatformState(): boolean {
    return window.navigator.onLine;
  }

  protected _getUnconfirmedStatusFromPlatformState(isNavigatorOnline: boolean): NetworkStatus {
    return isNavigatorOnline ? NetworkStatus.Online : NetworkStatus.Offline;
  }

  protected _resolveOfflineClaim(): NetworkStatus {
    // Trust this
    return NetworkStatus.Offline;
  }

  protected async _resolveOnlineClaim(): Promise<NetworkStatus> {
    // https://linear.app/readwise/issue/RW-9659/browser-extension-makes-requests-to-icanhaszip-on-every-single-tab
    if (isExtension) {
      return NetworkStatus.Online;
    }

    return await checkIfReallyOnline() ? NetworkStatus.Online : NetworkStatus.Offline;
  }

  protected _subscribeToPlatformStateChanges() {
    window.addEventListener('offline', () => {
      this._onPlatformStateUpdated(false);
    });

    window.addEventListener('online', () => {
      this._onPlatformStateUpdated(true);
    });
  }
}

export default new NetworkDetector();
